import { makeObservable, observable, action } from 'mobx';

import { resolveTranslation } from '../constants';
import { Translations } from '../models';
import { HttpResponse } from '../api';
import { RootStore } from '.';

export class TranslationsStore {
  
  private rootStore: RootStore;

  public translations = new HttpResponse<Translations>({});

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      translations: observable,
      setTranslations: action.bound,
    });
  }

  public setTranslations(value: HttpResponse<Translations>): void {
    this.translations = value;
  }

  public updateTranslations(value: Translations): void {
    this.setTranslations(this.translations.fetched(value || {}));
  }

  public translate(alias: string): string {
    // Local fallback before the alias itself, so a key the backend has not shipped never reaches a player.
    return resolveTranslation(this.translations.data, alias);
  }

}
